import { formatISO9075 } from 'date-fns';

export function mapFormDataToObject<T = { [key: string]: any }>(
  formData: FormData,
  ...numberKeys: string[]
): T {
  const json: Record<string, any> = {};

  formData.forEach((value, key) => {
    if (json[key] === undefined) {
      if (numberKeys?.find((k) => k === key)) {
        json[key] = parseInt(value as string);
      } else {
        json[key] = value;
      }
    } else {
      if (!Array.isArray(json[key])) {
        json[key] = [json[key]];
      }

      json[key].push(value);
    }
  });

  return json as T;
}

export function mapObjectToFormData(json: object) {
  const formData = new FormData();

  Object.entries(json).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        formData.append(key, v);
      });
    } else if (typeof value === 'boolean') {
      formData.set(key, value ? '1' : '0');
    } else if (value instanceof Date) {
      const formatted = formatISO9075(value, { representation: 'date' });

      formData.set(key, formatted);
    } else if (value instanceof File) {
      value.size !== 0 && formData.set(key, value);
    } else if (typeof value === 'object') {
      formData.set(key, JSON.stringify(value));
    } else {
      formData.set(key, value);
    }
  });

  return formData;
}

export function mapBooleanFormValues(formData: FormData, ...keys: string[]) {
  keys.forEach((key) => {
    const value = formData.get(key);

    if (value === 'on' || value === 'true') {
      formData.set(key, '1');
    } else {
      formData.set(key, '0');
    }
  });
}

export function removeEmptyFile(data: FormData, key: string) {
  const currentValue = data.get(key)?.valueOf();

  if (typeof currentValue === 'object' && currentValue instanceof File) {
    if (currentValue.size === 0) {
      data.delete(key);
    }
  }
}
